import React, { useEffect } from 'react';
import { useRecState } from '../../Orchestrator/Recoils/Events/Recoil';
import CookieConsentBanner from './CookieConsentBanner';
import CookieManagementModal from './CookieManagementModal';
import { _eventBus } from '../../core/events/EventBus';
import { cookieTree } from '../../Orchestrator/ConstantTree';

const CookieConsent: React.FC = () => {
  const [cookieConsentGiven] = useRecState<boolean>('cookieConsentGivenAtom');
  const [bannerVisible] = useRecState<boolean>('cookieConsentBannerVisibleAtom');
  const [modalVisible] = useRecState<boolean>('cookieManagementModalVisibleAtom');

  // Note: Cookie initialization is now handled by the CookiesInitStep in the flow
  // No need to initialize here as it's handled at the application level

  const handleAcceptAll = () => {
    _eventBus.emit({
      eventName: cookieTree.Consent.Accept.All,
      data: undefined
    });
  };

  const handleAcceptNecessary = () => {
    _eventBus.emit({
      eventName: cookieTree.Consent.Accept.Necessary,
      data: undefined
    });
  };

  const handleManageSettings = () => {
    _eventBus.emit({
      eventName: cookieTree.Consent.Manage.Settings.Open,
      data: { 
        showModal: true 
      }
    });
  };

  const handleSavePreferences = (newPreferences: Record<string, boolean>) => {
    _eventBus.emit({
      eventName: cookieTree.Consent.Save.Preferences,
      data: {
        preferences: newPreferences,
        cookieConsentGiven
      }
    });
  };

  const handleCloseModal = () => {
    _eventBus.emit({
      eventName: cookieTree.Consent.Manage.Settings.Close,
      data: {
        showModal: false,
        cookieConsentGiven
      }
    });
  };

  return (
    <>
      {bannerVisible && (
        <CookieConsentBanner
          onAcceptAll={handleAcceptAll}
          onManageSettings={handleManageSettings}
          onAcceptNecessary={handleAcceptNecessary}
        />
      )}

      <CookieManagementModal
        isOpen={modalVisible}
        onClose={handleCloseModal}
        onSavePreferences={handleSavePreferences}
        onAcceptNecessary={handleAcceptNecessary}
      />
    </>
  );
};

export default CookieConsent; 